import { create } from "zustand";
import { ColumnFiltersState, SortingState } from "@tanstack/react-table";
import Conversation from "@/models/conversation/Conversation";

interface ConversationTableState {
  data: Conversation[];
  search: string;
  pageCount: number;
  pageIndex: number;
  pageSize: number;
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
  setTableState: (state: Partial<ConversationTableState>) => void;
  resetTableState: () => void;
}

export const useConversationTableStore = create<ConversationTableState>(
  (set) => ({
    data: [],
    search: "",
    pageCount: 0,
    pageIndex: 0,
    pageSize: 10,
    sorting: [],
    columnFilters: [],
    setTableState: (state) => set((prev) => ({ ...prev, ...state })),
    resetTableState: () =>
      set({
        data: [],
        search: "",
        pageCount: 0,
        pageIndex: 0,
        pageSize: 10,
        sorting: [],
        columnFilters: [],
      }),
  })
);
